var React = require('react');

function IcNavUnderline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.903 9.294V3H18v12.196h-3.05V13.23h-.344c-.492 1.13-1.624 2.164-3.861 2.164C8.04 15.393 6 13.45 6 10.279V3h3.099v6.984c0 1.697.983 2.704 2.754 2.704 1.993 0 3.05-1.23 3.05-3.394zm-8.9 8.67h11.992v2.903H6.003v-2.902z","fill":"currentColor"}));
}

IcNavUnderline.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = IcNavUnderline;

IcNavUnderline.default = IcNavUnderline;
